/**
 * Modo solo lectura del tenant (US6 · FR-015 · T090).
 *
 * Cuando `me.company.status === 'SUSPENDED'` la API responde `423 READ_ONLY` a toda mutación
 * salvo `/auth/logout` y `/me/*` (contracts/admin-api.md). La UI se adelanta: deshabilita los
 * botones de mutación y explica por qué con un `title` (tooltip nativo, accesible por teclado).
 *
 * `banners.tsx` muestra además el aviso permanente "Empresa suspendida · solo lectura".
 */
import { t } from '../../i18n';

import { isReadOnly, useMe } from './use-me';

export interface ReadOnlyState {
  /** La empresa de la sesión está suspendida. */
  readOnly: boolean;
  /** Texto del tooltip a poner en los controles deshabilitados (`undefined` si no aplica). */
  reason: string | undefined;
}

/** Props listas para un botón de mutación: `disabled` + `title` cuando la empresa está suspendida. */
export function readOnlyProps(readOnly: boolean): { disabled?: true; title?: string } {
  return readOnly ? { disabled: true, title: t('common.banners.suspendedTooltip') } : {};
}

export function useReadOnly(): ReadOnlyState {
  const me = useMe();
  const readOnly = isReadOnly(me.data);
  return {
    readOnly,
    reason: readOnly ? t('common.banners.suspendedTooltip') : undefined,
  };
}
